import React, { useState, useEffect } from "react";
import { Variables } from "../../Variables1/Variables";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Row,
  Col,
  Modal,
  Button,
  Form,
  Card,
  FormCheck,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import Cookies from "js-cookie";
var sortJsonArray = require("sort-json-array");

function DirectionsList(props) {
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const [Permissions, setPermissions] = useState(
    Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  );

  const [sorting, setSorting] = useState("Asc");

  const [loader, setLoader] = useState(false);
  const [directions, setDirections] = useState([]);
  const [search, SetSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [addModalShow, SetAddModalShow] = useState(false);
  const [directionsAddToDb, setDirectionAddToDb] = useState({
    DirectionId: 0,
    DirectionName: "",
    IsDefault: false,
  });

  const [directionsUpdateToDb, setDirectionUpdateToDb] = useState({
    DirectionId: 0,
    DirectionName: "",
    IsDefault: false,
  });
  const [updateModalShow, setUpdateModalShow] = useState(0);

  //#region  Sorting

  const [nameSort, setNameSort] = useState("asc");
  const [publishSort, setPublishSort] = useState("asc");

  // sort by name
  const SortByName = () => {
    var copy = [...filteredData];
    if (nameSort == "asc") {
      var x = sortJsonArray(copy, "DirectionName", "des");
      setNameSort("des");
    } else {
      var x = sortJsonArray(copy, "DirectionName");
      setNameSort("asc");
    }
    setFilteredData(x);
  }

  // sort by isPublished
  const SortByIsDefault = () => {
    var copy = [...filteredData];
    if (publishSort == "asc") {
      var x = sortJsonArray(copy, "IsDefault", "des");
      setPublishSort("des");
    } else {
      var x = sortJsonArray(copy, "IsDefault");
      setPublishSort("asc");
    }
    setFilteredData(x);
  }
  //#endregion

  // Get Directions
  const GetDirections = async () => {
    setLoader(true);
    let response = await fetch(Variables.API_URL + "Direction/GetDirections", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    let result = await response.json();

    if (response.status === 200) {
      setDirections(result);
      setFilteredData(result);
    }
    setLoader(false);
  };

  // handle Search
  const handleSearch = (event) => {
    let value = event.target.value.toLowerCase();
    let result = [];
    SetSearch(value);
    result = directions.filter((data) => {
      return data.DirectionName.toLowerCase().search(value) !== -1;
    });
    setFilteredData(result);
  };

  // Clear Directions Add To Db
  function ClearDirectionAddToDb() {
    SetAddModalShow(false);
    setDirectionAddToDb({
      DirectionId: 0,
      DirectionName: "",
      IsDefault: false,
    });
  }

  // Set Add To Db
  function SetAddToDb() {
    SetAddModalShow(true);
    setDirectionAddToDb({
      DirectionId: 0,
      DirectionName: "",
      IsDefault: false,
    });
  }

  // Set Update ToDb
  function SetUpdateToDb(id, name, isDefault) {
    setUpdateModalShow(id);
    SetUpdateToDb({
      DirectionId: 0,
      DirectionName: "",
      IsDefault: false,
    });
  }

  // Clear Direction Update To Db
  function ClearDirectionUpdateToDb() {
    setUpdateModalShow(0);
    setDirectionUpdateToDb({
      DirectionId: 0,
      DirectionName: "",
      IsDefault: false,
    });
  }

  // handle Add Inputs
  function handleAddInputs(e) {
    const { value } = e.target;
    var element;
    if (value === "") {
      element = document.getElementById("DirectionsNameToAdd");
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById("DirectionNameToAdd");
      element.classList.remove("is-invalid");
    }
    setDirectionAddToDb((prevState) => ({
      ...prevState,
      ["DirectionName"]: value,
    }));
  }

  // Check input validity
  function IsValidToAdd() {
    var hasError = false;
    var element;
    if (
      directionsAddToDb.DirectionName === null ||
      directionsAddToDb.DirectionName === ""
    ) {
      element = document.getElementById("DirectionNameToAdd");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // Add new Direction
  const AddNewDirection = async () => {
    var Valid = IsValidToAdd();
    if (Valid) {
      let response = await fetch(
        Variables.API_URL + "Direction/AddNewDirection",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            DirectionId: directionsAddToDb.DirectionId,
            DirectionName: directionsAddToDb.DirectionName,
            IsDefault: directionsAddToDb.IsDefault,
          }),
        }
      );
      let result = await response.json();
      if (response.status === 200) {
        toast.success(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        SetAddModalShow(false);
        setDirectionAddToDb({
          DirectionId: 0,
          DirectionName: "",
          IsDefault: false,
        });
        GetDirections();
      } else {
        toast.error(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      toast.error("Please Select Direction Name", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  // handle Updatee Inputs
  function handleUpdateInputs(e) {
    const { value } = e.target;
    var element;
    if (value === "") {
      element = document.getElementById("DirectionNameToUpdate");
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById("DirectionNameToUpdate");
      element.classList.remove("is-invalid");
    }
    setDirectionUpdateToDb((prevState) => ({
      ...prevState,
      ["DirectionName"]: value,
    }));
  }

  // Handle Update IsDefault
  const HandleUpdateIsDefault = () => {
    if (directionsUpdateToDb.IsDefault === true) {
      setDirectionUpdateToDb((prevState) => ({
        ...prevState,
        IsDefault: false,
      }));
    } else {
      setDirectionUpdateToDb((prevState) => ({
        ...prevState,
        IsDefault: true,
      }));
    }
  };

  // Check input validity
  function IsValidToUpdate() {
    var hasError = false;
    var element;
    if (
      directionsUpdateToDb.DirectionName === null ||
      directionsUpdateToDb.DirectionName === ""
    ) {
      element = document.getElementById("DirectionNameToUpdate");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // Update Direction
  const UpdateDirection = async () => {
    var Valid = IsValidToUpdate();
    if (Valid) {
      let response = await fetch(
        Variables.API_URL + "Direction/UpdateDirection",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            DirectionId: directionsUpdateToDb.DirectionId,
            DirectionName: directionsUpdateToDb.DirectionName,
            IsDefault: directionsUpdateToDb.IsDefault,
          }),
        }
      );
      let result = await response.json();
      if (response.status === 200) {
        toast.success(result, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setUpdateModalShow(0);
        setDirectionUpdateToDb({
          DirectionId: 0,
          DirectionName: "",
          IsDefault: false,
        });
        GetDirections();
      } else {
        toast.error(result, {
          position: "top-right",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } else {
      toast.error("Please Select Direction Name", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
    
   

      GetDirections();
  }, []);


  return (
    <div>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Directions List</h4>
              </div>
              {Permissions.ManageDirections === true && (
                <Button variant="primary" onClick={() => SetAddToDb()}>
                  Add New Direction
                </Button>
              )}
            </Card.Header>
            <Card.Body className="px-0">
              <Form.Control
                id="Search"
                name="Search"
                placeholder="Search"
                type="text"
                className="allignCenter"
                onChange={handleSearch}
              />
              {loader === true ? (
                <CustomSnipper />
              ) : (
                <div className="table-responsive">
                  <table
                    id="user-list-table"
                    className="table table-striped"
                    role="grid"
                    data-toggle="data-table"
                  >
                    <thead>
                      <tr className="ligth">
                        <th></th>
                        <th onClick={() => SortByName()}>Direction Name</th>
                        <th onClick={() => SortByIsDefault()}>IsDefault</th>
                        <th min-width="100px">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((tdata, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td>
                          <td>{tdata.DirectionName}</td>
                          <td>
                            <span
                              className={
                                tdata.IsDefault === false
                                  ? "badge bg-danger"
                                  : "badge bg-success"
                              }
                            >
                              Default Direction
                            </span>
                          </td>
                          <td>
                            {Permissions.ManageDirections === true && (
                              <div className="flex align-items-center list-user-action">
                                <Link
                                  className="btn btn-sm btn-icon btn-success"
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title=""
                                  data-original-title="Edit"
                                  to={"#"}
                                  onClick={() => {
                                    setDirectionUpdateToDb({
                                      DirectionId: tdata.DirectionId,
                                      DirectionName: tdata.DirectionName,
                                      IsDefault: tdata.IsDefault,
                                    });
                                    setUpdateModalShow(tdata.DirectionId);
                                  }}
                                >
                                  <span className="btn-inner">
                                    <svg
                                      width="20"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                      <path
                                        d="M15.1655 4.60254L19.7315 9.16854"
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      ></path>
                                    </svg>
                                  </span>
                                </Link>{" "}
                                <Modal
                                  show={updateModalShow == tdata.DirectionId}
                                  onHide={() => ClearDirectionUpdateToDb()}
                                >
                                  <Modal.Header closeButton>
                                    <Modal.Title as="h5">
                                      Update Direction :{" "}
                                      {directionsUpdateToDb.DirectionName}
                                    </Modal.Title>
                                  </Modal.Header>
                                  <Modal.Body>
                                    <Row>
                                      <Form.Group className="col-md-12 form-group">
                                        <Form.Label htmlFor="lname">
                                          Direction Name:
                                        </Form.Label>
                                        <Form.Control
                                          id="DirectionNameToUpdate"
                                          name="DirectionNameToUpdate"
                                          placeholder="Direction Name"
                                          type="text"
                                          value={
                                            directionsUpdateToDb.DirectionName
                                          }
                                          onChange={handleUpdateInputs}
                                        />
                                      </Form.Group>
                                    </Row>
                                    <Row>
                                      <Form.Group className="col-lg-6 col-md-6 col-sm-12 form-group">
                                        <Form.Label htmlFor="fname">
                                          Is Default :
                                        </Form.Label>
                                        <Form.Check className="mb-3 form-check">
                                          <FormCheck.Input
                                            type="checkbox"
                                            className=""
                                            id="IsDefautToUodate"
                                            checked={
                                              directionsUpdateToDb.IsDefault
                                            }
                                            onChange={(e) =>
                                              HandleUpdateIsDefault()
                                            }
                                          />
                                          <FormCheck.Label
                                            className=""
                                            htmlFor="exampleCheck1"
                                          >
                                            Is Default
                                          </FormCheck.Label>
                                        </Form.Check>
                                      </Form.Group>
                                    </Row>
                                  </Modal.Body>
                                  <Modal.Footer>
                                    <Button
                                      variant="secondary"
                                      onClick={() => setUpdateModalShow(0)}
                                    >
                                      Close
                                    </Button>
                                    <Button
                                      variant="primary"
                                      onClick={() => UpdateDirection()}
                                    >
                                      Save changes
                                    </Button>
                                  </Modal.Footer>
                                </Modal>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  <Modal
                    show={addModalShow}
                    onHide={() => ClearDirectionAddToDb()}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title as="h5">Add New Direction</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Row>
                        <Form.Group className="col-md-12 form-group">
                          <Form.Label htmlFor="lname">
                            Direction Name:
                          </Form.Label>
                          <Form.Control
                            id="DirectionNameToAdd"
                            name="DirectionNameToAdd"
                            placeholder="Direction Name"
                            type="text"
                            value={directionsAddToDb.DirectionName}
                            onChange={handleAddInputs}
                          />
                        </Form.Group>
                      </Row>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        variant="secondary"
                        onClick={() => SetAddModalShow(false)}
                      >
                        Close
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() => AddNewDirection()}
                      >
                        Save changes
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default DirectionsList;
